import React, { Component } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import Select from 'components/Form/Select';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';

const schemaValidation = Yup.object().shape({
	tube: Yup.number().required('Champ requis'),
	added_reason: Yup.string().required('Champ requis'),
});

class AddTubeModal extends Component {
	render() {
		const { open, tubeReasons, tubeLibrary, close, tubes } = this.props;
		return (
			<Modal size='small' open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Header>Ajouter un tube</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						tube: '',
						added_reason: '',
					}}
					validationSchema={schemaValidation}
					onSubmit={(values) => {
						this.props.submit(values);
						this.props.close();
					}}
				>
					{({ submitForm }) => (
						<>
							<Modal.Content>
								<Form>
									<Field
										component={Select}
										name='tube'
										customlabel='Tube'
										placeholder='Sélectionner un tube'
										options={tubeLibrary.list.filter(tl => !tubes.some(t => t.properties.code === tl.code)).map((tube) => ({
											value: tube.id,
											label: `${tube.sil_code} - ${tube.label}`,
										}))}
										required
									/>
									<Field
										component={Select}
										name='added_reason'
										customlabel='Motif'
										options={tubeReasons.added.map((reason) => ({
											value: reason.label,
											label: reason.label,
										}))}
										isCreatable
										required
									/>
								</Form>
							</Modal.Content>

							<Modal.Actions>
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close();
									}}
								>
									<Icon name='remove' /> Annuler
								</Button>
								<Button
									primary
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										submitForm();
									}}
								>
									<Icon name='save' /> Confirmer
								</Button>
							</Modal.Actions>
						</>
					)}
				</Formik>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tubeReasons: state.tubeReasons,
		tubeLibrary: state.tubeLibrary,
	};
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTubeModal);
